import { fg } from '@atlaskit/platform-feature-flags';

export const checkInvoiceableAndCanAddPaymentDetails = (
	isInvoiceable: boolean | null | undefined,
	canAddPaymentDetails: boolean | null | undefined,
) => {
	if (fg('block_twc_ea_on_confluence_when_pde')) {
		if (isInvoiceable === false && canAddPaymentDetails) {
			return true;
		} else {
			return false;
		}
	}
	return true;
};
